//#region src/schema/helpers/format-value.ts
function e(e) {
	return Array.isArray(e) ? `[${e.map((e) => typeof e == "string" ? `"${e.toString().trim()}"` : typeof e == "object" ? JSON.stringify(e) : e === void 0 ? "undefined" : e === null ? "null" : e).join(", ")}]` : e === null ? "null" : typeof e == "object" ? JSON.stringify(e) : e === void 0 ? "undefined" : typeof e == "string" ? e.trim() : e.toString().trim();
}
//#endregion
export { e as formatValue };

//# sourceMappingURL=format-value.js.map